import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../../state/actions'
import { browserHistory } from 'react-router'
import style from './styles.less'
import { Navbar, Nav, NavDropdown, MenuItem } from 'react-bootstrap'

class Navigation extends Component {
    constructor(props) {
        super(props)

        this.dropdownAction = this.dropdownAction.bind(this)
    }

    dropdownAction(value) {
        var self = this
        if (value === 'logout') {
            self.props.actions.userCleanProfile()
        } else if (value === 'perfil') {
            browserHistory.push({
                pathname: '/manager/' + self.props.profile.app.codename + '/user/edit/me'
            })
        } else if (value === 'apps') {
            browserHistory.push({
                pathname: '/manager/app'
            })
        }
    }

    render() {
        var self = this
        var goToProfile = null
        if (self.props.profile && self.props.profile.app) {
            goToProfile = <MenuItem eventKey={'perfil'}><i className="fa fa-home fa-fw"></i> Perfil</MenuItem>
        }
        var goToApps = null
        if (self.props.profile && self.props.profile.profile == 2000) {
            goToApps = <MenuItem eventKey={'apps'}><i className="fa fa-laptop fa-fw"></i> Apps</MenuItem>
        }

        return (
            <Navbar className={style.navbar} fluid>
                <Navbar.Header>
                    <Navbar.Brand>
                        {/* <a onClick={self.props.onTitleClick ? self.props.onTitleClick : null}>{self.props.title}</a> */}
                        <div className="brand"></div>
                    </Navbar.Brand>
                    <Navbar.Toggle />
                </Navbar.Header>
                <Navbar.Collapse>
                    <Nav>
                        { self.props.children }
                    </Nav>
                    <Nav pullRight>
                        <NavDropdown onSelect={self.dropdownAction} title={<i className="fa fa-user fa-fw"></i>} id="nav-dropdown">
                            { goToApps }
                            { goToProfile }
                            <MenuItem eventKey={'logout'}><i className="fa fa-sign-out fa-fw"></i> Logout</MenuItem>
                        </NavDropdown>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        )
    }

}

Navigation.propTypes = {
    title: PropTypes.string.isRequired,
    onTitleClick: PropTypes.func
}

function mapStateToProps(state) {
    return {
        profile: state.profile,
        routing: state.routing
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Navigation)



// WEBPACK FOOTER //
// ./components/common/Navigation/index.js